import { baseApi } from "./baseApi";

const TRIP_BASE_URL = "/trip";

export const tripApi = baseApi.injectEndpoints({
  tagTypes: ["Trip"],

  endpoints: (build) => ({
    addTrip: build.mutation({
      query: (body) => ({
        url: TRIP_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Trip", id: "LIST" }],
    }),
    listTrips: build.query({
      query: (params) => ({
        url: TRIP_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Trip", _id })),
              { type: "Trip", id: "LIST" },
            ]
          : [{ type: "Trip", id: "LIST" }],
    }),
    getDDLTripList: build.query({
      query: (params) => ({
        url: `${TRIP_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: "Trip", id })),
              { type: "Trip", id: "DDL" },
            ]
          : [{ type: "Trip", id: "DDL" }],
    }),
    getTripDetail: build.query({
      query: (tripId) => `${TRIP_BASE_URL}/${tripId}`,
      providesTags: (result, error, { _id }) => [
        { type: "Trip", _id },
        { type: "Trip", id: "LIST" },
      ],
    }),
    updateTrip: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${TRIP_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "Trip", id },
        { type: "Trip", id: "LIST" },
      ],
    }),

listTripLoadings: build.query({
  query: ({ tripId, ...restParams }) => ({
    url: `${TRIP_BASE_URL}/${tripId}/tripLoadings`,
    params: restParams,
  }),
  providesTags: (result, error, { tripId }) => [
    { type: "Trip", id: tripId },
    { type: "Trip", id: "LIST" },
  ],
}),

    addTripLoading: build.mutation({
      query: (payload) => {
        const { tripId, ...body } = payload;
        return {
          url: `${TRIP_BASE_URL}/${tripId}/tripLoadings`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, { tripId }) => [
        { type: "Trip", id: tripId },
        { type: "Trip", id: "LIST" },
      ],
    }),
    updateTripLoading: build.mutation({
      query: (payload) => {
        const { tripId, loadingId, ...body } = payload;
        return {
          url: `${TRIP_BASE_URL}/${tripId}/tripLoadings/${loadingId}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { tripId }) => [
        { type: "Trip", id: tripId },
        { type: "Trip", id: "LIST" },
      ],
    }),
  }),

  overrideExisting: false,
});

export const {
  useAddTripMutation,
  useListTripsQuery,
  useLazyGetDDLTripListQuery,
  useLazyGetDDLTripQuery,
  useLazyListTripsQuery,
  useGetTripDetailQuery,
  useUpdateTripMutation,
  useListTripLoadingsQuery,
  useLazyListTripLoadingsQuery,
  useAddTripLoadingMutation,
  useUpdateTripLoadingMutation,
} = tripApi;